import { render, staticRenderFns } from "./PageWithFooter.vue?vue&type=template&id=3a6b9084&scoped=true&"
import script from "./PageWithFooter.vue?vue&type=script&lang=js&"
export * from "./PageWithFooter.vue?vue&type=script&lang=js&"
import style0 from "./PageWithFooter.vue?vue&type=style&index=0&id=3a6b9084&prod&scoped=true&lang=css&"
import style1 from "./PageWithFooter.vue?vue&type=style&index=1&id=3a6b9084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6b9084",
  null
  
)

export default component.exports